export default {
  messages: {
    required: "هذاالحقل مطلوب",
    numeric: "يجب إدخال قيمة رقمية",
    max: "لا يمكن تجاوز الحد الأقصى المسموح به",
    digits: "يجب أن يتكون الحقل من عدد محدد من الأرقام",
    idNumber: "الرقم الوطني",
    policyNumber: "رقم البوليصة",
    mobile: "رقم الموبايل",
  },
};
